const { debounce } = window.BAO.Utils

class CartItem extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['remove']
  }

  constructor () {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? window.BAO.sectionRenderer.pushCartSections
      : this.onCartPage
        ? window.BAO.sectionRenderer.cartSections
        : []
    this.cart = null
  }

  setupListeners () {
    super.setupListeners()

    this.removeLineItem = this.removeLineItem.bind(this)
    this.onQuantityChange = this.onQuantityChange.bind(this)
    this.debouncedOnQuantityChange = debounce((event) => {
      this.onQuantityChange(event)
    }, 500)

    if (this.els?.remove.exists) {
      this.listeners.add(this.els.remove.element, 'click', this.removeLineItem)
    }

    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.debouncedOnQuantityChange,
    )
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  async removeLineItem (e) {
    e.preventDefault()

    this.loading = true

    // Remove any associated monogram items
    const response = await fetch('/cart.js')
    this.cart = await response.json()

    const itemBeingRemoved = this.cart.items.find(item => item.key === this.dataset.key)
    const monogramRef = itemBeingRemoved.properties._pc_pricing_ref
    const reAddProductVariant = await this.removeMonogramProduct(monogramRef)

    let state = await window.BAO.Cart.removeItem(this.dataset.key, {
      sections: this.mappedSections,
    })

    // Re-add the product associated with the monogram if monogram is deleted. Don't re-add if deleted product
    if (reAddProductVariant && itemBeingRemoved.product_type === 'PPLR_HIDDEN_PRODUCT') {
      const cartItem = {
        id: reAddProductVariant.variantId,
        quantity: reAddProductVariant.quantity,
      }

      console.log('cartItem', cartItem)

      state = await window.BAO.Cart.addItem(cartItem, {
        sections: this.mappedSections,
      })
    }

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  async removeMonogramProduct(monogramRef) {
    if (!monogramRef) return

    const allItemsWithMonogramRef = this.cart.items.filter(item => item.properties._pc_pricing_ref === monogramRef)
    const monogramItem = allItemsWithMonogramRef.find(item => item.product_type === 'PPLR_HIDDEN_PRODUCT')
    const productItem = allItemsWithMonogramRef.find(item => item.product_type !== 'PPLR_HIDDEN_PRODUCT')
    const linkedProductKey = this.cart.items.find(item => item.properties._pc_pricing_ref === monogramRef && item.key !== this.dataset.key)?.key

    if (linkedProductKey) {
      await window.BAO.Cart.removeItem(linkedProductKey, { sections: this.mappedSections })

      return {
        variantId: productItem.variant_id,
        quantity: productItem.quantity,
      }
    }

    return null
  }

  async onQuantityChange (e) {
    this.loading = true

    const state = await window.BAO.Cart.updateQuantity(
      this.dataset.key,
      e.detail.value,
      { sections: this.mappedSections },
    )

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }

  get loading () {
    return this._loading
  }

  set loading (val) {
    this._loading = val

    if (this.inPushCart) {
      this.pushCart.loading = val
    }

    this.setAttribute('aria-busy', val.toString())
  }

  get pushCart () {
    return this.closest('push-cart')
  }

  get inPushCart () {
    return this.pushCart != null
  }

  get onCartPage () {
    return this.cart != null
  }
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', CartItem)
}
